module.exports = __webpack_public_path__ + "images/1efb75a7f12e23eb431b11b18f64c90a.png";